import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin: 0 3%;
  min-height: 100%;
`;

export const ConfigCard = styled.div`
  width: 100%;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 12px;
  align-items: end;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ConfigTitle = styled.h3`
  margin: 0;
  grid-column: 1 / -1;
  font-size: 16px;
  color: #303030;
`;

export const ConfigField = styled.div`
  width: 100%;

  label,
  span {
    display: block;
    margin-bottom: 6px;
    color: #303030;
  }
`;

export const Select = styled.select`
  width: 100%;
  height: 40px;
  border-radius: 5px;
  border: 1px solid #d9d9d9;
  padding: 0 10px;
  font-size: 14px;
`;

export const ConfigActions = styled.div`
  display: flex;
  justify-content: flex-end;
`;
